'use strict';

function WealthInterstitial() {
  this.id = null;
  this.node = null;
  this.extends = [_WealthController, // instantiates _productSettings
  Interstitial // instantiates _product
  ];
  this.contentId = ''; // 'wealth' (defined in pug file)

  this.init = function () {
    this._super();

    var MEMBER_CONTENTS_KEY = this.contentId + '-interstitial';

    // user must view interstitial content only once
    if (this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
      this.history.replaceUrl(Product.shortcutMappings[this.contentId + '-overview']);
    } else {
      this.initPage();
    }
  };

  this.initPage = function () {
    // this._super(); // optional when need to call the controllers initPage() instead.
    this.initInterstitial();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyInterstitial();
  };
}